module.exports = {"430523100":"塘渡口镇","430523101":"白仓镇","430523102":"金称市镇","430523103":"塘田市镇","430523104":"黄亭市镇","430523105":"长阳铺镇","430523106":"岩口铺镇","430523107":"九公桥镇","430523108":"下花桥镇","430523109":"谷洲镇","430523110":"郦家坪镇","430523111":"五峰铺镇","430523201":"小溪市乡","430523203":"长乐乡","430523204":"蔡桥乡","430523205":"河伯乡","430523206":"黄荆乡","430523207":"诸甲亭乡","430523208":"罗城乡","430523209":"金江乡","430523401":"七里山园艺场","430523402":"五丰铺林场","430523403":"河伯岭林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430523.json
// module id = 1692
// module chunks = 0